<template>
  <div class="card-detail request-detail-card">
    <div class="card-detail-title">
      <span v-if="request.date">{{ request.date | date }}</span>
    </div>
    <div>
      <signature-banner
        v-if="signature"
        :signature="signature"
        :can-discard="false"
        :can-retry="canSignRequest"
        :running-description="runningDescription"
        @retry="sign"
      />
    </div>
    <div class="card-detail-data">
      <div class="card-drug" v-for="(expense, e) in request.expenses"
           :key="`${expense.id}${e}`">
        {{ expense.code | tuss }} - {{ expense.name }} ( x{{ expense.quantity }} )
      </div>
      <div class="request-detail-actions">
        <template v-if="isSigned">
          <st-button-report
            type="pdf"
            button-class="btn-primary"
            label="Imprimir solicitação assinada"
            :icon="['fal', 'file-signature']"
            :options="null"
            :route="printRoute"
          ></st-button-report>
          <button
            v-if="isExam"
            type="button"
            class="btn btn-gray-outline btn-icon btn-icon-left ml-2"
            :class="{ loading: loadingPrint }"
            :disabled="loadingPrint"
            @click="print(true)"
          ><fa-icon :icon="['fal', 'file-invoice']" /> Guia SP/SADT</button>
        </template>
        <template v-else>
          <button class="btn btn-info btn-icon btn-action"
                  :class="{loading: loadingPrint}"
                  :disabled="loadingPrint || isSignatureRunning"
                  @click="print(false)">
            <fa-icon :icon="['fal', 'print']"></fa-icon>
          </button>
          <button
            v-if="isExam"
            class="btn btn-gray btn-icon btn-icon-left ml-2"
            :class="{loading: loadingPrint}"
            :disabled="loadingPrint || isSignatureRunning"
            @click="print(true)">
            <fa-icon :icon="['fal', 'print']"></fa-icon> SADT
          </button>
          <button
            v-if="canSignRequest && !signature"
            type="button"
            class="btn btn-gray btn-icon btn-icon-left ml-2"
            @click="sign"
          ><fa-icon :icon="['fal', 'signature']" /> Assinar</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import digitalSignatureMixin from '@/mixins/digital-signature';
import SignatureBanner from '@/components/digital-signature/SignatureBanner.vue';
import {
  MEDICAL_RECORD_EXAM_REQUEST,
  MEDICAL_RECORD_HOSPITALIZATION_REQUEST,
} from '@/data/digital-signature';

export default {
  mixins: [digitalSignatureMixin],
  digitalSignatureRealtime: false,
  components: {
    SignatureBanner,
  },
  props: {
    medicalRecordId: {
      type: String,
      required: true,
    },
    request: {
      type: Object,
      required: true,
    },
    kind: {
      type: String,
      default: 'exam',
    },
    canSign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingPrint: false,
      runningDescription: 'A solicitação assinada fica disponível para impressão assim que o Bird ID concluir.',
    };
  },
  created() {
    this.signature = this.request.digitalSignature || null;
  },
  watch: {
    'request.digitalSignature': function syncFromRequest(value) {
      this.signature = value || null;
    },
    signature(value) {
      if (this.request.digitalSignature !== value) {
        this.$set(this.request, 'digitalSignature', value);
      }
    },
  },
  computed: {
    isExam() {
      return this.kind === 'exam';
    },
    signatureType() {
      return this.isExam ? MEDICAL_RECORD_EXAM_REQUEST : MEDICAL_RECORD_HOSPITALIZATION_REQUEST;
    },
    printRoute() {
      return `/medical-records/${this.medicalRecordId}/${this.kind}-requests/${this.request.id}/print`;
    },
    canSignRequest() {
      return this.canSign && this.isDigitalSignatureEnabled;
    },
  },
  methods: {
    isOwnDigitalSignature(data) {
      return data.type === this.signatureType && data.itemId === this.request.id;
    },
    sign() {
      if (!this.canSignRequest) {
        return;
      }
      this.requestDigitalSignature(this.medicalRecordId, {
        type: this.signatureType,
        itemId: this.request.id,
        pageSize: 'A4',
      });
    },
    print(spsadt) {
      this.loadingPrint = true;
      const params = this.isExam ? { spsadt } : {};
      const client = this.isExam && !this.isSigned ? this.$file : this.$fileX;
      return client
        .print(this.printRoute, params)
        .catch(this.$toast.error)
        .finally(() => {
          this.loadingPrint = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.request-detail-card {
  .request-detail-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: $layout-spacing-sm 0;
    margin-top: $layout-spacing;
  }
}
</style>
